import React, { useContext } from 'react';

import {
  Flex,
  Container,
  Text, LegacyText,
  Box,
  TransparentButton,
  Divider,
} from 'flicket-ui';

import { useRouter } from 'next/router';
import {
  Layout,
  Footer,
  BottomBar,
  Menu,
  Seo,
  Icon,
  ContentContainer,
  SlateRenderer,
} from '~components';
import { BaseContext } from '~context';

const PrivacyPolicy = () => {
  const router = useRouter();
  const { organization } = useContext(BaseContext);

  return (
    <>
      <Seo title="Privacy Policy" description="Privacy Policy" />
      <Menu />
      <Flex flexDirection="column" flex={1}>
        <Box d={{ _: 'block', md: 'none' }}>
          <Flex px={2} py={3}>
            <TransparentButton mr={2} onClick={() => router.back()}>
              <Icon icon="chevron-left" fontSize={6} color="N800" />
            </TransparentButton>
            <LegacyText
              lineHeight="normal"
              fontSize={6}
              fontWeight="extraBold"
              color="N800"
            >
              Privacy Policy
            </LegacyText>
          </Flex>
          <Divider />
        </Box>
        <Flex
          flexDirection="column"
          flex={1}
          maxH={{ _: 'calc(100vh - 73px)', md: 'unset' }}
          overflowY={{ _: 'auto', md: 'visible' }}
        >
          <Layout layoutType="overlay">
            <ContentContainer variant="content">
              <Flex flexDir="column" pb={{ _: 2, md: 0 }} flex="1">
                <Box
                  d={{ _: 'none', md: 'block' }}
                  width="100%"
                  maxWidth="1248px"
                  pl={4}
                  mx={'auto' as any}
                >
                  <TransparentButton onClick={() => router.back()}>
                    <Flex alignItems="center" opacity="inherit">
                      <Icon icon="chevron-left" fontSize={5} color="white" />
                      <LegacyText
                        color="white"
                        fontWeight="extraBold"
                        fontSize={3}
                        lineHeight="medium"
                        ml="3/4"
                      >
                        Back
                      </LegacyText>
                    </Flex>
                  </TransparentButton>
                  <LegacyText
                    color="white"
                    fontWeight="heavy"
                    fontSize={9}
                    lineHeight={'56px' as any}
                    my={1}
                  >
                    Privacy Policy
                  </LegacyText>
                </Box>
                <Container
                  innerProps={{ minHeight: { _: 0, md: '320px' } }}
                  mb={{ _: 0, md: 10 }}
                >
                  {organization?.privacyPolicy ? (
                    <SlateRenderer value={organization?.privacyPolicy} />
                  ) : (
                    <LegacyText mb={{ _: 1, md: 2 }}>
                      Privacy Policy coming soon!
                    </LegacyText>
                  )}
                </Container>
              </Flex>
              <Footer />
            </ContentContainer>
          </Layout>
        </Flex>
      </Flex>
      <BottomBar />
    </>
  );
};

export default PrivacyPolicy;
